import { Component, createRef } from "react";
import { NSALayout, NSALayoutProps } from "namirasoft-account-react";
import { AccountRoutes } from "./AccountRoutes";

export class AccountLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<NSALayoutProps<RowType, RowTypeInput>>
{
    NSALayout_Ref = createRef<NSALayout<RowType, RowTypeInput>>();

    override render()
    {
        return (
            <NSALayout
                ref={this.NSALayout_Ref}
                {...this.props}
                alerts={[
                    {
                        title: {
                            title: "Verify your email",
                            description: "Please go to your profile and verify your email address."
                        },
                        onClick: () => { this.props.url.redirect(AccountRoutes.VerifyEmail, {}) },
                        isVisible: () =>
                        {
                            let user = this.props.account.token_manager.get()?.user;
                            if (!user)
                                return false;
                            return !user.e_verified;
                        },
                        button_text: "Verify Now"
                    },
                    {
                        title: {
                            title: "Verify your phone number",
                            description: "Please go to your profile and verify your phone number."
                        },
                        onClick: () => { this.props.url.redirect(AccountRoutes.VerifyPhone, {}) },
                        isVisible: () =>
                        {
                            let user = this.props.account.token_manager.get()?.user;
                            if (!user)
                                return false;
                            let phone = user?.phone;
                            if (phone)
                                return !user.p_verified;
                            return false;
                        },
                        button_text: "Verify Now"
                    },
                    {
                        title: {
                            title: "Phone number was not filled",
                            description: "You have not entered your phone number. Please update your profile with your phone number."
                        },
                        onClick: () => { this.props.url.redirect(AccountRoutes.UserProfile, {}) },
                        isVisible: () =>
                        {
                            let user = this.props.account.token_manager.get()?.user;
                            if (!user)
                                return false;
                            return !user.phone
                        },
                        button_text: "Go to Profile"
                    },
                    ...(this.props.alerts ?? [])
                ]}
                header={{
                    enabled: this.props.header?.enabled,
                    built_in: {
                        workspace: false
                    }
                }}
            >
                {this.props.children}
            </NSALayout >
        );
    }
}